import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useNoteStyles = makeStyles<Theme>(() => ({
  root: {
    position: 'relative',
    padding: '1rem',
    borderBottom: '0.5px solid rgba(224, 224, 224, 1)'
  },
  footer: {
    color: 'gray',
    fontSize: '10pt',
    marginTop: '6px'
  },
  content: {
    fontSize: '11pt'
  },
  child: {
    paddingTop: '4px'
  },
  badge: {
    position: 'absolute',
    top: '2px',
    right: '2px'
  }
}));
